module.exports = __webpack_public_path__ + "img/default.946b9abd.svg";